import React from "react";
import { FaCalendarCheck, FaClock } from "react-icons/fa";
import moment from "moment";

const DateStrip = React.memo(({ selectedDate, selectedTime }) => {
  console.log("selectedTime", selectedTime);

  // Format the date properly
  const formattedSelectedDate = selectedDate
    ? moment(selectedDate).format("DD MMM, YYYY")
    : "";

  // Handle timezone correctly
  const formattedSelectedTime = selectedTime
    ? moment(selectedTime).local().format("hh:mm A") // Use `.local()` for correct timezone
    : "";

  return (
    <div className="pt-5 py-2">
      <p className="text-sm font-bold text-gray-700">Scheduled for</p>
      <div className="flex justify-between items-center mt-2 rounded-md bg-gray-100 p-2">
        {/* Date Section */}
        <div className="flex items-center w-1/2">
          <div className="w-10 h-10 p-1 flex items-center justify-center">
            <FaCalendarCheck className="text-gray-700 text-xl" />
          </div>
          <p className="text-xs font-bold text-gray-700 truncate">
            {formattedSelectedDate}
          </p>
        </div>

        {/* Time Section */}
        <div className="flex items-center w-2/5 pr-2 justify-end">
          <div className="w-10 h-10 p-1 flex items-center justify-center">
            <FaClock className="text-gray-700 text-xl" />
          </div>
          <p className="text-xs font-bold text-gray-700 truncate">
            {formattedSelectedTime}
          </p>
        </div>
      </div>
    </div>
  );
});

export default DateStrip;
